
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"40","viewBox":"0 -960 960 960","width":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M315.725-184.173q-18.667 0-31.37-12.703t-12.703-31.37q0-18.667 12.703-31.37t31.37-12.703h261.594q62.102 0 106.232-42.328t44.13-104.049q0-61.289-44.13-103.927-44.13-42.638-106.232-42.638H312.29l69.811 69.811q12.87 13.071 12.87 30.971 0 17.899-12.87 30.957-12.869 13.058-30.869 13.058t-30.87-13.246L175.231-577.899q-6.618-6.715-10.026-14.841-3.409-8.127-3.409-16.635 0-8.509 3.409-16.607 3.408-8.097 10.026-14.787l145.131-144.565q12.87-12.87 30.87-12.87t30.869 13.032q12.87 13.031 12.87 30.869 0 17.839-12.87 30.709l-69.811 70.188h264.363q98.593 0 169.072 68.094t70.479 166.24q0 98.145-70.479 166.522t-169.072 68.377H315.725z"}})])
          )
        }
      }
    